import { DS } from './designTokens';

export const formatFormStatus = (
  status: string,
  submittedAt?: string | null
): string => {
  switch (status) {
    case 'pending':
      return 'Ej påbörjad';
    case 'inProgress':
      return 'Påbörjad';
    case 'submitted': {
      const date = submittedAt
        ? new Date(submittedAt).toLocaleString('sv-SE', {
            dateStyle: 'medium',
            timeStyle: 'short',
          })
        : '';
      return `Inskickad (${date})`;
    }
    default:
      return 'Ej påbörjad';
  }
};

export const statusColor = (status: string): string => {
  if (status === 'submitted') return DS.deepTeal;
  if (status === 'inProgress') return DS.amber;
  return DS.muted;
};
